import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { HotToastService } from '@ngxpert/hot-toast';
import { IssueService } from '../../../services/issue.service';
import { IssueDeveloperNotes } from '../../../models/issue';

export interface DeveloperNotesDialogData {
  issueId: string;
  issueNumber: number;
}

@Component({
  selector: 'app-developer-notes-dialog',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule
  ],
  templateUrl: './developer-notes-dialog.component.html',
  styleUrls: ['./developer-notes-dialog.component.scss']
})
export class DeveloperNotesDialogComponent implements OnInit {
  private issueService = inject(IssueService);
  private toast = inject(HotToastService);
  private dialogRef = inject<MatDialogRef<DeveloperNotesDialogComponent, IssueDeveloperNotes>>(MatDialogRef);
  data = inject<DeveloperNotesDialogData>(MAT_DIALOG_DATA);

  notes = '';
  loading = true;
  saving = false;
  lastEdit: IssueDeveloperNotes | null = null;

  ngOnInit(): void {
    this.issueService.getDeveloperNotes(this.data.issueId).subscribe({
      next: n => {
        this.notes = n.notes ?? '';
        this.lastEdit = n;
        this.loading = false;
      },
      error: () => {
        this.loading = false;
        this.toast.error('Could not load developer notes');
        this.dialogRef.close();
      }
    });
  }

  save(): void {
    this.saving = true;
    this.issueService.saveDeveloperNotes(this.data.issueId, { notes: this.notes }).subscribe({
      next: n => {
        this.saving = false;
        this.toast.success('Developer notes saved');
        this.dialogRef.close(n);
      },
      error: () => {
        this.saving = false;
        this.toast.error('Could not save developer notes');
      }
    });
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
